import { render, staticRenderFns } from "./PermissionRolesTable.vue?vue&type=template&id=1e16d8a4"
import script from "./PermissionRolesTable.vue?vue&type=script&lang=js"
export * from "./PermissionRolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports